import React from "react";
import { Link } from "@reach/router";
import MobileMenuItem from "./MobileMenuItem";
import { cuenta } from "../../utils";

const MobileMenu = ({ signOut, user }) => {
  return (
    <nav
      className="panel-mobile-menu navbar navbar-main navbar-expand-lg navbar-dark shadow-sm align-items-center"
      style={{ backgroundColor: "#27272b" }}
    >
      <div className="container-fluid navbar-container ps-0 ps-md-auto">
        <Link className="navbar-brand flex-shrink-0 py-2 px-2" to="/">
          <img
            src="https://tbmcerts.s3.us-west-1.amazonaws.com/tbmcerts-logo.png"
            className="logo-navbar"
            alt="logo"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mobileMenuCollapse"
          aria-controls="mobileMenuCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="mobileMenuCollapse">
          <ul className="navbar-nav nav me-auto ps-3">
            {cuenta.map(({ name, handle }) => (
              <li key={name} className="nav-item">
                <Link className="nav-link" to={handle} style={{ color: "white" }}>
                  {name}
                </Link>
              </li>
            ))}
            <li className="nav-item">
              <button
                className="nav-link text-danger border-0 bg-transparent"
                onClick={signOut}
              >
                <i className="fa fa-sign-out-alt me-2"></i> Salir
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default MobileMenu;
